import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';

import Styles from './styles';

let C;

class CesiumViewer extends Component {
  cesiumViewer = React.createRef();

  state = {
    clientModulesReady: false,
    isViewerLoaded: false
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) this.loadClientModules();
  }

  componentDidUpdate() {
    const { clientModulesReady } = this.state;
    if (clientModulesReady) this.loadViewer();
  }

  loadViewer = async () => {
    const { isViewerLoaded } = this.state;
    const { mapId, updateViewerState } = this.props;
    // const response = await fetch(
    //   'https://sd1.3dtiles.ipsilum.com/1las_3dtiles_color/PNOA_2020_AND-NW_232-4100_ORT-CLA-IRC/',
    //   {
    //     method: 'GET',
    //     headers: { 'Content-Type': 'application/json' }
    //   }
    // );
    // const terrainProvider = new C.CesiumTerrainProvider({
    //   //   url: 'https://twsusewebsvr02.agi.com/stk-terrain/v1/tilesets/world/tiles',
    //   url:
    //     'https://sd1.d3.ipsilum.com/3dtiles/1las_3dtiles_color/PNOA_2020_AND-NW_232-4100_ORT-CLA-IRC/tileset.json',
    //   requestVertexNormals: true
    // });

    if (!isViewerLoaded) {
      C.Ion.defaultAccessToken =
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2ZGJjMTRlMi05OGEzLTRmN2EtYWM1YS1lZWEwNzk1MTJkZWEiLCJpZCI6MzI4NjEsInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1OTc2Nzk1MTJ9.klLApuKzrQ8VDAYhLpcYGrfL09cfxRh6dghlR2GmC-E';
      this.cesiumViewer = new C.Viewer(mapId, {
        animation: false,
        baseLayerPicker: false,
        fullscreenButton: false,
        imageryProvider: () => '',
        navigationHelpButton: false,
        sceneModePicker: false,
        scene3DOnly: true,
        selectionIndicator: false,
        shouldAnimate: false,
        terrainProvider: C.createWorldTerrain(),
        timeline: false,
        useBrowserRecommendedResolution: true
      });
      this.cesiumViewer.canvas.style.width = '100%';
      this.cesiumViewer.canvas.style.height = '100%';
      updateViewerState(true);
      this.setState({ isViewerLoaded: true });
    }
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      C = await import('cesium');
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const { height, isAtlas, isFixedHeight, isFullScreen, mapId } = this.props;
    return (
      <Styles.Viewer
        height={height}
        id={mapId}
        isAtlas={isAtlas}
        isFullScreen={isFullScreen}
        isFixedHeight={isFixedHeight}
      />
    );
  }
}

CesiumViewer.defaultProps = {
  height: '100vh',
  isAtlas: false,
  isFixedHeight: false,
  isFullScreen: false,
  updateViewerState: () => console.warn('LeafletUpdateState not set')
};

CesiumViewer.propTypes = {
  height: PropTypes.string,
  isAtlas: PropTypes.bool,
  isFixedHeight: PropTypes.bool,

  isFullScreen: PropTypes.bool,
  mapId: PropTypes.string.isRequired,
  updateViewerState: PropTypes.func
};

export default CesiumViewer;
